import { useEffect, useRef } from 'react';
import { processAllReminders } from '../services/reminderProcessor';

export function useReminderProcessor(enabled = true, intervalMs = 60000) {
  const timerRef = useRef<number | null>(null);
  
  const processReminders = async () => {
    try {
      const result = await processAllReminders();
      if (result.processed > 0) {
        console.log(`Processed ${result.processed} reminders:`, result.results);
      }
    } catch (error) {
      console.error('Error processing reminders:', error);
    }
  };
  
  useEffect(() => {
    // Check if we're in development mode
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    // DISABLED: We no longer run the reminder processor automatically in any environment
    // In production, Vercel's cron job handles this
    // In development, we don't want automatic processing
    if (false && enabled && isDevelopment) {
      console.log('Starting development-mode reminder processor');
      
      // Process immediately on mount
      processReminders();
      
      // Set up interval to check periodically
      timerRef.current = window.setInterval(processReminders, intervalMs);
    } else {
      if (isDevelopment) {
        console.log('Client-side reminder processor disabled in development. Use manual testing instead.');
      } else {
        console.log('Client-side reminder processor disabled in production, using Vercel cron job instead.');
      }
    }
    
    return () => {
      if (timerRef.current !== null) {
        window.clearInterval(timerRef.current);
      }
    };
  }, [enabled, intervalMs]);
  
  // Still return the function so it can be manually triggered if needed
  return { processReminders };
} 